var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnfollow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6498 3.4002C8.6498 4.89136 7.44097 6.1002 5.9498 6.1002C4.45863 6.1002 3.2498 4.89136 3.2498 3.4002C3.2498 1.90903 4.45863 0.700195 5.9498 0.700195C7.44097 0.700195 8.6498 1.90903 8.6498 3.4002Z",
    fill: "#4318FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3498 13.3002C11.3498 10.3179 8.93214 7.9002 5.9498 7.9002C2.96747 7.9002 0.549805 10.3179 0.549805 13.3002H11.3498Z",
    fill: "#4318FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4498 5.2002C9.95274 5.2002 9.5498 5.60314 9.5498 6.1002C9.5498 6.59725 9.95274 7.0002 10.4498 7.0002H14.0498C14.5469 7.0002 14.9498 6.59725 14.9498 6.1002C14.9498 5.60314 14.5469 5.2002 14.0498 5.2002H10.4498Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollow);
export default __webpack_public_path__ + "static/media/unfollow.95df8e7280a137a976de78e10b7a8feb.svg";
export { ForwardRef as ReactComponent };